<template>
  <div>
    <div
      v-if="loading"
      class="text-center py-2"
    >
      <b-spinner
        label="Loading"
        variant="primary"
      />
    </div>

    <b-alert
      variant="danger"
      :show="loadingError ? true : false"
    >
      <div class="alert-body">
        <p>
          {{ loadingError }}
        </p>
      </div>
    </b-alert>

    <b-form
      v-if="!loading && !loadingError"
      @submit.prevent="submitHandler"
    >
      <b-row>
        <b-col cols="12">
          <b-alert
            variant="danger"
            :show="errorMessage ? true : false"
          >
            <div
              v-if="typeof errorMessage === 'string'"
              class="alert-body"
            >
              <p>
                {{ errorMessage }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.detail"
              class="alert-body"
            >
              <p>
                {{ errorMessage.detail }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.non_field_errors"
              class="alert-body"
            >
              <p>
                {{ errorMessage.non_field_errors[0] }}
              </p>
            </div>
            <div
              v-else-if="errorMessage.message"
              class="alert-body"
            >
              <p>
                {{ errorMessage.message }}
              </p>
            </div>
          </b-alert>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="PDF File"
            label-for="pdf-file"
          >
            <div class="d-flex align-items-center">
              <div
                v-if="existingPdfFileUrl"
                style="width: 80px"
              >
                <a
                  :href="existingPdfFileUrl"
                  target="_blank"
                >
                  View File
                </a>
              </div>
            </div>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="Company Copy"
            label-for="company-copy"
          >
            <div class="d-flex align-items-center">
              <div
                v-if="existingCompanyCopyUrl"
                style="width: 80px"
              >
                <a
                  :href="existingCompanyCopyUrl"
                  target="_blank"
                >
                  View File
                </a>
              </div>
              <b-form-file
                id="company-copy"
                v-model="companyCopy"
                accept=".pdf"
              />
              <p
                v-if="errorMessage && errorMessage.company_copy"
                class="error-message"
              >
                {{ errorMessage.company_copy[0] }}
              </p>
            </div>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <label for="cn_date_of_marg">CN Date of Marg</label>
          <b-form-datepicker
            id="cn_date_of_marg"
            v-model="cnDateOfMarg"
            menu-class="w-100"
            calendar-width="100%"
            disabled
          />
          <p
            v-if="errorMessage && errorMessage.cn_date_of_marg"
            class="error-message"
          >
            {{ errorMessage.cn_date_of_marg[0] }}
          </p>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="CN Number of Company Document"
            label-for="cn-number-of-company-document"
          >
            <b-form-input
              id="cn-number-of-company-document"
              v-model="cnNumberOfCompanyDocument"
              type="text"
              placeholder="Enter CN Number of Company Document"
              disabled
            />
            <p
              v-if="errorMessage && errorMessage.cn_number_of_company_document"
              class="error-message"
            >
              {{ errorMessage.cn_number_of_company_document[0] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="CN Number of issue Marg"
            label-for="cn-number-of-issue-marg"
          >
            <b-form-input
              id="cn-number-of-issue-marg"
              v-model="cnNumberOfIssueMarg"
              type="text"
              placeholder="Enter CN Number of issue Marg"
              disabled
            />
            <p
              v-if="errorMessage && errorMessage.cn_number_of_issue_marg"
              class="error-message"
            >
              {{ errorMessage.cn_number_of_issue_marg[0] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <label for="datepicker-full-width-1">CN Date of Company</label>
          <b-form-datepicker
            id="datepicker-full-width-1"
            v-model="cnDateOfCompany"
            menu-class="w-100"
            calendar-width="100%"
          />
          <p
            v-if="errorMessage && errorMessage.cn_date_of_company"
            class="error-message"
          >
            {{ errorMessage.cn_date_of_company[0] }}
          </p>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="CN Items Count"
            label-for="cn-items"
          >
            <b-form-input
              id="cn-items"
              v-model="cnItemsCount"
              type="number"
              placeholder="CN Items Count"
              disabled
            />
            <p
              v-if="errorMessage && errorMessage.cn_items_count"
              class="error-message"
            >
              {{ errorMessage.cn_items_count[0] }}
            </p>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <b-form-group
            label="CN Amount"
            label-for="amount"
          >
            <b-form-input
              id="amount"
              v-model="cnAmount"
              type="number"
              placeholder="CN Amount"
              disabled
            />
            <p
              v-if="errorMessage && errorMessage.cn_amount"
              class="error-message"
            >
              {{ errorMessage.cn_amount[0] }}
            </p>
          </b-form-group>
        </b-col>

        <b-col
          cols="12"
          md="6"
          lg="4"
        >
          <label for="textarea-default">Remarks</label>
          <b-form-textarea
            id="textarea-default"
            v-model="remarks"
            rows="3"
          />
          <p
            v-if="errorMessage && errorMessage.remarks"
            class="error-message"
          >
            {{ errorMessage.remarks[0] }}
          </p>
        </b-col>
      </b-row>

      <b-button
        class="mt-1 mr-1"
        variant="secondary"
        @click="cancel()"
      >
        Cancel
      </b-button>
      <b-button
        variant="primary"
        :disabled="saving"
        class="mt-1 mr-1"
        type="submit"
      >
        Update
        <b-spinner
          v-if="saving"
          small
          label="Small Spinner"
        />
      </b-button>
    </b-form>
  </div>
</template>

<script>
import {
  BRow, BCol, BFormGroup, BButton, BFormInput, BFormTextarea, BFormDatepicker, BFormFile, BForm, BSpinner, BAlert,
} from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BRow,
    BCol,
    BFormFile,
    BFormGroup,
    BFormInput,
    BForm,
    BFormDatepicker,
    BFormTextarea,
    BButton,
    BSpinner,
    BAlert,
  },
  props: {
    creditNoteId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: true,
      loadingError: null,
      existingPdfFileUrl: null,
      existingCompanyCopyUrl: null,
      companyCopy: null,
      cnDateOfMarg: null,
      cnNumberOfCompanyDocument: null,
      cnNumberOfIssueMarg: null,
      cnDateOfCompany: null,
      cnItemsCount: null,
      cnAmount: null,
      remarks: '',
      saving: false,
      errorMessage: {},
    }
  },
  created() {
    this.fetchDetails()
  },
  methods: {
    fetchDetails() {
      this.loading = true
      this.loadingError = null

      axios.get(`/returns/supplier_credit_note/${this.creditNoteId}/`)
        .then(res => {
          this.existingPdfFileUrl = res.data.pdf_file || null
          this.existingCompanyCopyUrl = res.data.company_copy || null
          this.cnDateOfMarg = res.data.cn_date_of_marg || null
          this.cnNumberOfCompanyDocument = res.data.cn_number_of_company_document || null
          this.cnNumberOfIssueMarg = res.data.cn_number_of_issue_marg || null
          this.cnDateOfCompany = res.data.cn_date_of_company || null
          this.cnItemsCount = res.data.cn_items_count ?? null
          this.cnAmount = res.data.cn_amount ?? null
          this.remarks = res.data.remarks || ''
        })
        .catch(error => {
          this.loadingError = error?.response?.data?.detail
            || error?.response?.data?.error
            || 'Something went wrong'
        })
        .finally(() => {
          this.loading = false
        })
    },
    submitHandler(event) {
      event.preventDefault()
      const formData = new FormData()

      if (this.companyCopy instanceof File) {
        formData.append('company_copy', this.companyCopy)
      }
      if (this.cnDateOfCompany) {
        formData.append('cn_date_of_company', this.cnDateOfCompany)
      }
      formData.append('remarks', this.remarks || '')

      this.saving = true
      this.errorMessage = {}

      axios.patch(`/returns/supplier_credit_note/${this.creditNoteId}/`, formData)
        .then(res => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: res.data.message || 'Supplier Credit Note Updated',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })

          this.$emit('item-updated')
        }).catch(error => {
          this.errorMessage = error?.response?.data || 'Something went wrong'
        }).finally(() => {
          this.saving = false
        })
    },
    cancel() {
      this.$emit('cancelled')
    },
  },
}

</script>

<style scoped>
.error-message {
  color: red
}
</style>
